export const normalizeHolderIdentity = (value: string | undefined, isForeign: boolean): string | null => {
  if (isForeign || !value) return null;

  return value.replace(/\D/g, '');
};
